<div style="padding: 10px 10px 10px 10px">
    <form [formGroup]="formulario">

        <div mat-dialog-title>Novo status</div>

        <div class="row">
            <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>Status</mat-label>
                <mat-select formControlName="NovoStatus">
                    <mat-option *ngFor="let status of selectStatus" [value]="status">
                        {{status}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row" *ngIf="formulario.value.NovoStatus == 'Atendido'">
            <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Solução</mat-label>
                <textarea matInput style="width: 100%; height: 100%;"
                    formControlName="DescricaoSolucao"></textarea>
            </mat-form-field>
        </div>

        <div class="row justify-content-end">
            <button mat-raised-button (click)="gravar()" class="mr-2"
                [disabled]="formulario.value.NovoStatus == 'Atendido' && formulario.value.DescricaoSolucao == ''"
                color="primary">Gravar</button>
            <button mat-raised-button class="mr-2" color="warn" mat-dialog-close>Cancelar</button>
        </div>
    </form>
</div>